<script setup lang="ts">import {Check, HeartHandshake, Microscope, ShieldCheck} from 'lucide-vue-next'</script>
<template>
  <div>
    <section class="page-hero">
      <div class="container"><span class="eyebrow">Unsere Praxis</span>
        <h1>Fachlich bestens versorgt.<br><em>Menschlich gut aufgehoben.</em></h1>
        <p>Eine ruhige Atmosphäre, moderne Behandlungsmethoden und Zeit für Ihre Fragen.</p></div>
    </section>
    <section class="section">
      <div class="container philosophy-grid">
        <div class="practice-visual">
          <div class="room-lines"></div>
          <span class="experience"><strong>30+</strong><small>Jahre Erfahrung<br>in Musterstadt</small></span></div>
        <div class="philosophy-copy dark-copy"><span class="eyebrow">Unser Anspruch</span>
          <h2>Wir betrachten nicht nur Zähne, sondern den ganzen Menschen.</h2>
          <p>Eine gute Mundgesundheit trägt wesentlich zum Wohlbefinden des gesamten Körpers bei. Deshalb planen wir
            jede Behandlung individuell und mit Blick auf langfristig stabile Ergebnisse.</p>
          <p>Regelmäßige Fortbildungen und eine angenehme Praxisatmosphäre bilden die Basis für eine Versorgung, der Sie
            vertrauen können.</p>
          <div class="values"><span><Check/> Zeit für Ihre Fragen</span><span><Check/> Individuelle Therapieplanung</span><span><Check/> Substanzschonendes Vorgehen</span>
          </div>
        </div>
      </div>
    </section>
    <section class="section practice-values">
      <div class="container"><span class="eyebrow">Was uns wichtig ist</span>
        <h2 class="standalone-title">Qualität, die Sie spüren.</h2>
        <div class="home-features">
          <div>
            <HeartHandshake/>
            <h3>Persönlichkeit</h3>
            <p>Wir hören zu, erklären verständlich und entscheiden gemeinsam.</p></div>
          <div>
            <Microscope/>
            <h3>Präzision</h3>
            <p>Sorgfältige Diagnostik und moderne Verfahren.</p></div>
          <div>
            <ShieldCheck/>
            <h3>Nachhaltigkeit</h3>
            <p>Unser Ziel ist der langfristige Erhalt Ihrer Mundgesundheit.</p></div>
        </div>
      </div>
    </section>
  </div>
</template>
